import { render } from "./ReferenceItemForm.vue?vue&type=template&id=2d1b4848&scoped=true"
import script from "./ReferenceItemForm.vue?vue&type=script&lang=js"
export * from "./ReferenceItemForm.vue?vue&type=script&lang=js"

import "./ReferenceItemForm.vue?vue&type=style&index=0&id=2d1b4848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1b4848"]])

export default __exports__